export default __webpack_public_path__ + "static/media/heroMobile.fd8f4cde.webp";